import { Injectable } from '@angular/core';
import {ProjectConstants} from '../app/project-constants';
import {GeneralServices} from './general-services';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GeneralServicesImplService extends ProjectConstants implements GeneralServices {

  constants: ProjectConstants;

  constructor(protected http: HttpClient) {
    super();
  }

  delete(url: string, id: number): Observable<any> {
    url = url + '/' + id;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.delete(url, {headers: header, responseType: 'json'})
      .pipe(
        map (data => data)
      );
  }

  get(url: string, filters: any, offset?: any): Observable<any> {
    url = url + this.LINKS.LIST;
    const body =  filters;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: offset})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getListInAllSettings(url: string, filters: any, offset?: any): Observable<any> {
    url = url + this.LINKS.LIST_IN_ALL_SETTINGS;
    const body =  filters;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: offset})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getAll(url: string, filters: any, offset?: any): Observable<any> {
    url = url + this.LINKS.LIST;
    const body =  filters;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: offset})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getById(url: string) {
  }

  save(url: string, object: any) {
    const body =  object;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  saveMassive(url: string, object: any) {
    url = url + this.LINKS.MULTI_INSERT;
    const body =  object;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  update(url: string, object: any) {
    const body =  object;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.put( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  updateMassive(url: string, object: any) {
    url = url + this.LINKS.MULTI_UPDATE;
    const body =  object;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.put( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }
}
